/* tslint:disable */

declare var Object: any;
export interface SfrequestforInterface {
  "id"?: number;
}

export class Sfrequestfor implements SfrequestforInterface {
  "id": number;
  constructor(data?: SfrequestforInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Sfrequestfor`.
   */
  public static getModelName() {
    return "Sfrequestfor";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Sfrequestfor for dynamic purposes.
  **/
  public static factory(data: SfrequestforInterface): Sfrequestfor{
    return new Sfrequestfor(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Sfrequestfor',
      plural: 'Sfrequestfors',
      path: 'Sfrequestfors',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Sfrequestfor.ts